<template>
	<div>
	<header id="header">
		<div class="container">
			<div class="num_b" style="display: none;" data-counter-time="2000" data-counter-delay="50"></div>
			<div id="logo">
				<router-link to="/"><img :src="imgPrefix + 'static/logo.jpg'" /></router-link>
			</div>
			<nav id="nav">
				<ul>
					<li><router-link to="/" class="parent">首页</router-link></li>
					<li>
						<router-link to="/product.html" class="parent">产品信息</router-link>
						<div class="navlist" v-if="routePath === '/product.html'">
							<a v-for="(item, index) in this.product_categorys" @click="goAnchor('/product.html?floor-'+(index+1), 'floor-'+(index+1))">{{ item.cname }}</a>
						</div>
            <div class="navlist" v-else>
              <a v-for="(item, index) in this.product_categorys" @click="goAnchor('/product.html', 'floor-'+(index+1))">{{ item.cname }}</a>
            </div>
					</li>
					<li>
						<router-link to="/service.html" class="parent">专业服务</router-link>
            <div class="navlist" v-if="routePath === '/service.html'">
              <a @click="goAnchor('/service.html?service', 'service')">服务范畴</a>
              <a @click="goAnchor('/service.html?quality', 'quality')">高端品质</a>
              <a @click="goAnchor('/service.html?speciality', 'speciality')">专业服务</a>
            </div>
            <div class="navlist" v-else>
              <a @click="goAnchor('/service.html', 'service')">服务范畴</a>
              <a @click="goAnchor('/service.html', 'quality')">高端品质</a>
              <a @click="goAnchor('/service.html', 'speciality')">专业服务</a>
            </div>
					</li>
					<li>
						<router-link to="/news.html" class="parent">新闻动态</router-link>
						<div class="navlist">
              <router-link to="/news.html">企业动态</router-link>
              <router-link to="/industryNews.html">行业新闻</router-link>
              <router-link to="/commonSense.html">印刷常识</router-link>
						</div>
					</li>
					<li>
						<router-link to="/about.html" class="parent">关于我们</router-link>
            <div class="navlist" v-if="routePath === '/about.html'">
              <a @click="goAnchor('/about.html?about', 'about')">公司简介</a>
              <a @click="goAnchor('/about.html?culture', 'culture')">企业文化</a>
              <a @click="goAnchor('/about.html?iso', 'iso')">体系认证</a>
              <a @click="goAnchor('/about.html?customer', 'customer')">合作客户</a>
            </div>
            <div class="navlist" v-else>
              <a @click="goAnchor('/about.html', 'about')">公司简介</a>
              <a @click="goAnchor('/about.html', 'culture')">企业文化</a>
              <a @click="goAnchor('/about.html', 'iso')">体系认证</a>
              <a @click="goAnchor('/about.html', 'customer')">合作客户</a>
            </div>
					</li>
					<li>
						<router-link to="/contact.html" class="parent">联系我们</router-link>
            <div class="navlist" v-if="routePath === '/contact.html'">
              <router-link to="/contact.html">联系我们</router-link>
              <a @click="goAnchor('/contact.html?jobs', 'jobs')">人才招聘</a>
            </div>
            <div class="navlist" v-else>
              <router-link to="/contact.html">联系我们</router-link>
              <a @click="goAnchor('/contact.html', 'jobs')">人才招聘</a>
            </div>
					</li>
				</ul>
			</nav>
			<div class="search">
				<form @submit.prevent="globalSearch">
					<input placeholder="请输入关键字..." v-model="globalSearchValue" />
					<input type="submit" class="submit" value="" />
				</form>
			</div>
			<div class="m-nav" @click="navShow">
				<!-- <img :src="imgPrefix + 'static/nav-icon.jpg'" /> -->
				<b></b>
				<b></b>
				<b></b>
			</div>
			<!-- <div class="m-search">
				<router-link to="/search.html">
				<img :src="imgPrefix + 'static/m-search.jpg'" />
				</router-link>
			</div> -->
			<div class="m-search">
				<router-link to="/search.html">
				<img :src="imgPrefix + '/static/search.svg'" />
				</router-link>
			</div>
			<div class="moblie-nav" v-if="showNav">
				<header>快捷导航 <span @click="closeNav"><img :src="imgPrefix + 'static/mobile-nav-close.jpg'" /></span></header>
				<ul>
					<li><router-link to="/">首页</router-link></li>
					<li><router-link to="/product.html">产品信息</router-link></li>
					<li><router-link to="/service.html">专业服务</router-link></li>
					<li><router-link to="/news.html">新闻动态</router-link></li>
					<li><router-link to="/about.html">关于我们</router-link></li>
					<li><router-link to="/contact.html">联系我们</router-link></li>
				</ul>
			</div>
			<div class="mobile-nav-bg" v-if="showNav" @click="closeNav"></div>
		</div>
	</header>

	<div class="headHeight"></div>

	</div>
</template>

<script>
	import {getProductCategoryList} from "../axios/api";

  export default {
		name: 'Header',
		data() {
		  return {
        imgPrefix: process.env.PREFIX_IMG,
        routePath: this.$route.path,
			  globalSearchValue:'',
			  showNav:false,
			  product_categorys: [],
		  }
		},
		mounted() {

		  this.getProductCategorys();
		  // this.pageScroll();
		  this.scrollHeader(function(direction) {
		    var docHeight = $(document).height();
		    var winScrollHeight = $(window).scrollTop()+$(window).height();
		    if(winScrollHeight >= docHeight) return false;
				
			var winWidth = document.documentElement.clientWidth;
			if(winWidth>991||winWidth<767){
		      if(direction == 'down'){
		        $("#header").css("top","-107px");
		      }else if(direction == 'up'){
		        $("#header").css("top","0px");
		      }

		      if($(document).scrollTop() <= 0) {
		        direction == 'up'
		        $("#header").css("top","0px");
		      }
			}
		  });
		},
		methods:{
      goAnchor(path, id) {
        localStorage.setItem("anchorId", id);
        this.$router.push({ path: path });
      },
			// pageScroll:function(){
			// 	$(window).scroll(function(){
			// 		if($(window).scrollTop() >= 300){
			// 			$("#header").addClass("fixed");
			// 		} else{
			// 			$("#header").removeClass("fixed");
			// 		}
			// 	});
			// },
			scrollHeader( fn ){
			  var beforeScrollTop = document.body.scrollTop || document.documentElement.scrollTop,
			    fn = fn || function() {};
			  window.addEventListener("scroll", function() {
			    var afterScrollTop = document.body.scrollTop || document.documentElement.scrollTop,
			      delta = afterScrollTop - beforeScrollTop;
			    var u = navigator.userAgent;
			    //android终端
			    var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
			    //ios终端
			    var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
			    if( delta === 0 ) return false;
			    //if(isAndroid || isIOS) return false;
			    fn( delta > 0 ? "down" : "up" );

			    beforeScrollTop = afterScrollTop;
			  }, false);
			},
			navShow:function(){
				this.showNav = true
			},
			closeNav:function(){
				this.showNav = false
			},
		  getProductCategorys(){
				getProductCategoryList({sort: 'sort', order: 'asc', filter_params: {'display_state': 1}}).then(response => {
				  this.product_categorys = response.data.data.list;
				}).catch(error => {
				console.log('请求异常信息：'+error);
			  });
			},
			globalSearch() {
			   // window.location.href = '/search.html?kw=' + this.globalSearchValue;
			  this.$router.push({ path: '/search.html', query: { kw: this.globalSearchValue } });
			  this.globalSearchValue = '';
			},
		}
	}
</script>

<style type="text/css" scoped>
	.headHeight{
		height: 98px;
	}
	a{
		color: inherit;
		text-decoration: none !important;
	}
	li{
		list-style: none;
	}
	.moblie-nav{
		width: 91%;
		min-height: 100%;
		background: #f7f7f7;
		position: fixed;
		z-index: 100;
		top: 0;
		bottom: 0;
		right: 0;
		overflow-x: hidden;
		overflow-y: auto;
		z-index: 1001;
		text-indent: 20px;

	}
	.mobile-nav-bg{
		position: fixed;
		width: 100%;
		height: 100%;
		left: 0;
		z-index: 99;
		top: 0;
		background: rgba(0,0,0,.6);

	}
	.moblie-nav ul li{
		line-height: 50px;
		border-bottom: 1px solid #eaeaea;
		background: url('https://img.ds-cy.com/static/mobile-nav-jt.jpg') no-repeat;
		background-position: 95% center;
	}
	.moblie-nav ul li a{
		display: block;
	}
	.moblie-nav header{
		line-height: 50px;
		border-bottom: 1px solid #eaeaea;
	}
	.moblie-nav header span{
		float: right;
		margin-right: 4.5%;
		position: relative;
		top: -1px;
	}
	.moblie-nav .router-link-exact-active{
		border: none;
		height: auto;
	}

	/* @media (min-width: 1200px) {
		.container,
		.container-sm,
		.container-md,
		.container-lg,
		.container-xl {
			max-width: 1400px;
		}
	} */

	#header {
		height: 98px;
		border-bottom: 2px solid #019ee6;
		background: #fff;
		-webkit-transition: all 0.2s ease;
		-o-transition: all 0.2s ease;
		transition: all 0.2s ease;
		position: fixed;
		top: 0;
		left: 0;
		z-index: 200;
		width: 100%;
	}

	#header.fixed{
		position: fixed;
		width: 100%;
		z-index: 999;
	}

	#header .search {
		float: right;
	}

	#header .container {
		padding-left: 60px;
		padding-right: 60px;
	}

	#logo {
		float: left;
		margin-right: 78px;
	}

	#nav {
		float: left;
		margin-top: 35px;
	}

	#nav ul li {
		float: left;
		font-size: 18px;
		color: #4e4e4e;
		margin-right: 38px;
		height: 33px;
		cursor: pointer;
		position: relative;
		padding-bottom: 63px;
	}

	#nav ul li .navlist{
		position: absolute;
		background: #0c141b;
		z-index: 999;
		width: 125px;
		top: 63px;
		display: none;
	}

	#nav ul li:hover .navlist{
		display: block;
	}

	#nav ul li .navlist a{
		display: block;
		line-height: 43px;
		color: #fff;
		font-size: 16px;
		text-indent: 20px;
	}

	#nav ul li .navlist a:hover{
		background: #0ea5ea;
		color: #fff;
	}

	#nav ul li.active {
		border-bottom: 2px solid #0ea5ea;
		color: #0ea5ea;
	}

	#nav ul li a.parent{
		position: relative;
		display: block;
		height: 33px;
	}

	#nav ul li a.parent::after{
		position: absolute;
		content: "";
		bottom: 14px;
		width: 0;
		height: 2px;
		background: #0ea5ea;
		left: 0;
		-webkit-transition: all .3s ease;
		-o-transition: all .3s ease;
		transition: all .3s ease;
		bottom: 0;
	}

	#nav .parent.router-link-exact-active{
		display: block;
		height: 33px;
		border-bottom: 2px solid #0ea5ea;
		color: #0ea5ea;
	}


	#nav ul li:hover .parent{
		/* border-bottom: 2px solid #0ea5ea; */
		color: #0ea5ea;
	}

	#nav ul li:hover a::after{
		width: 100%;
	}

	#nav ul li:hover .router-link-exact-active::after{
		width: 0;
	}


	#nav ul li:hover a.parent{
		color: #0ea5ea;
	}

	#header .search {
		width: 229px;
		height: 35px;
		border-radius: 30px;
		border: 1px solid #b7b7b7;
		margin-top: 32px;

	}

	#header .search input {
		background: none;
		border: none;
		outline: none;
		line-height: 31px;
		height: 31px;
		padding-left: 18px;
		width: 192px;
	}

	#header .search .submit{
		width: 20px;
		height: 20px;
		background: url('https://img.ds-cy.com/static/search.jpg') no-repeat;
		padding-left: 0;
		position: relative;
		top: 5px;
		float: right;
		margin-right: 10px;
	}

	.search input::placeholder {
		font-size: 14px;
		color: #b7b7b7;
	}

	#banner img {
		width: 100%;
	}

	.m-search{
		float: right;
		margin-top: 25px;
		margin-right: 28px;
		display: none;
	}

	.m-nav{
		float: right;
		margin-top: 21px;
		display: none;
		width: 40px;
		height: 40px;
		border: 1px solid #e6e6e6;
		border-radius: 5px;
	}

	.m-nav b{
		display: block;
		width: 20px;
		height: 3px;
		background: #666666;
		border-radius: 10px;
		margin: 3.5px auto;
	}

	.m-nav b:first-of-type{
		margin-top: 11px;
	}

	.m-search img{
		width: 33px;
	}

	.m-nav img{
		width: 56px;
	}

	@media (max-width:1439px) {
		#header .search{
			width: 180px;
		}
		#nav ul li{
			font-size: 17px;
			margin-right: 34px;
		}
		#logo{
			margin-right: 70px;
		}
		#header .search input{
			width: 144px;
		}
	}

	@media (max-width:1199px) {
		#logo{
			margin-right: 40px;
		}
		#nav ul li {
		    font-size: 16px;
		    margin-right: 28px;
		}
		.search{
		    width: 160px;
		}
		#logo img{
			width: 170px;
			margin-top: 5px;
		}
	}

	@media (max-width:992px) {

		#nav{
			display: none;
		}
		#header .search{
			display: none;
		}
		#advantage ul li{
		    width: 128px;
		    height: 128px;
		    margin: 0px 20px;
		}
		#advantage ul li .num{
		    font-size: 38px;
		    margin-top: 0;
			margin: 0 15px;
		}
		#header{
			height: 85px;
		}
		.headHeight{
			height: 85px;
		}
		#logo img{
			width: 164px;
			margin-top: 0;
		}
		.m-search{
			display: block;
		}
		.m-nav{
			display: block;
		}
	}

	@media (max-width:1199px) {

		.search{
			width: 150px;
		}
		#header .container{
			padding-left: 15px;
			padding-right: 15px;
		}
		#nav ul li .navlist a{
			font-size: 14px;
			line-height: 38px;
		}
	}


	@media (max-width:767px) {
		.m-nav{
			margin-top: 14px;
		}
		#header .container{
		    padding-left: 15px;
		    padding-right: 15px;
		}
		.m-nav img{
			width: 40px;
		}
		.m-search img{
			width: 23px;
		}
		.m-search{
			margin-top: 22px;
			margin-right: 22px;
		}
		#logo img{
			width: 135px;
			margin-top: -3px;
		}
		#header{
			height: 70px;
		}
		.headHeight{
			height: 70px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue